import React from 'react';

export default function SiteFooter({ year, name }) {
  return (
    <footer className="py-12 text-center border-t border-white/10">
      <p className="text-gray-500">{year} {name}</p>
    </footer>
  );
}
